import { GET_PASSPORT_DISABLED } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';

// =============================================================================
// Request & Response Model
// =============================================================================

// =============================================================================
// Mutation
// =============================================================================

interface GetPassportDisabledProps {
  onSuccess: (passportDisabled: Boolean) => void;
}

export const useGetPassportDisabled = ({ onSuccess }: GetPassportDisabledProps) => {
  const useGetPassportDisabled = async () => {
    const res = await axiosClient.get<Boolean>(GET_PASSPORT_DISABLED);

    return res.data;
  };

  return useCustomQuery([GET_PASSPORT_DISABLED], useGetPassportDisabled, { onSuccess });
};
